// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductsList_wrapper__XUIq2"};